import {buildAssistantEntityContext, type AssistantEntityContext} from '@dms/ai-assistant';
import type {CustomerResponseBodyV2} from '@dms/api/customer';
import type {LastActiveBusinessCaseResponseBody} from '@dms/api/sales';
import {getCustomerName} from '@dms/shared';

type CustomerIdentity = Pick<
  CustomerResponseBodyV2,
  'id' | 'discriminator' | 'foundingPerson' | 'businessInfo'
>;

/**
 * Records loaded by a mounted customer page. Returns `undefined` until the loaded customer belongs
 * to the route id, so a record switch cannot leak the previous customer or business case.
 * Customer grids expose no single canonical vehicle or interest id.
 */
export const getCustomerAssistantEntities = (
  customerId: string,
  customer: CustomerIdentity | undefined,
  activeBusinessCase: Pick<LastActiveBusinessCaseResponseBody, 'code' | 'id'> | null | undefined
): AssistantEntityContext | undefined =>
  customer?.id !== customerId
    ? undefined
    : buildAssistantEntityContext({
        customer: {id: customer.id, label: getCustomerName(customer)},
        businessCase: activeBusinessCase && {
          id: activeBusinessCase.id,
          label: activeBusinessCase.code,
        },
      });
